<div class="agpr-theme-sidebar">
    <div
        class="agpr-theme-sidebarHeader"
        [attr.aria-label]="'Social.intelligence.theme.toggleThemeDropdown' | localize"
        tabindex="0"
        (keyup)="toggleThemeDropdown($event)"
        (clickOutside)="closeThemeDropdown()"
    >
        <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
        <nav
            class="agpr-theme-sidebarHeaderGroup"
            (click)="toggleThemeDropdown()"
        >
            @if (isArchiveSearch) {
                <div class="agpr-theme-sidebarArchiveSearchIconWrapper">
                    <span
                        class="agpr-theme-sidebarArchiveSearchIcon fa-regular fa-duotone fa-cabinet-filing"
                        aria-hidden="true"
                    ></span>
                </div>

                <h1>{{ 'Social.intelligence.theme.lhp.archiveResults' | localize }}</h1>
            } @else {
                @if (currentTheme?.avatarUrl) {
                    <img
                        class="agpr-theme-sidebarHeaderImage"
                        [src]="currentTheme?.avatarUrl"
                        [alt]="currentTheme?.name"
                    />
                } @else {
                    <div
                        class="agpr-theme-sidebarHeaderImagePlaceholder"
                        [style.color]="currentTheme?.avatarPlaceholderColor"
                        [style.background-color]="currentTheme?.avatarPlaceholderBackgroundColor"
                        aria-hidden="true"
                    >
                        {{ currentTheme?.avatarPlaceholderText }}
                    </div>
                }

                <h1
                    [pTooltip]="currentTheme?.name"
                    tooltipPosition="bottom"
                >
                    {{ currentTheme?.name }}
                </h1>
                <!-- An automation agent is watching this theme -->
                @if (liveAgentCount(currentTheme)) {
                    <span
                        role="img"
                        class="agpr-theme-sidebarLiveAgentIcon fa-solid fa-signal-stream"
                        [pTooltip]="liveAgentTooltip(currentTheme)"
                        tooltipPosition="bottom"
                        [attr.aria-label]="liveAgentTooltip(currentTheme)"
                    ></span>
                }
            }
        </nav>
        <div>
            <span
                class="agpr-theme-sidebarHeaderArrow fa-solid fa-angle-right"
                (click)="toggleThemeDropdown()"
            ></span>
            @if (showThemeDropdown) {
                <div class="agpr-theme-sidebarHeaderDropdown">
                    @if (isArchiveSearch) {
                        <button
                            class="agpr-theme-sidebarHeaderDropdown-menuItem"
                            (click)="openArchiveSearchWidget(archiveSearchMode.create)"
                        >
                            {{ 'Social.intelligence.theme.lhp.newArchiveSearch' | localize}}
                        </button>

                        <div class="agpr-theme-sidebarHeaderDropdown-divider"></div>

                        @if (themes.length > 0) {
                            <div class="agpr-theme-sidebarHeaderDropdown-label">
                                {{ 'Social.intelligence.theme.lhp.themesQuickAccess' | localize}}
                            </div>
                        }
                    }
                    <agpr-scroll-panel>
                        <ul
                            id="themeDropdown_themeList"
                            class="agpr-theme-sidebarHeaderDropdown-themesContainer"
                            agprListKeyboardNavigation
                            [focusOnChild]="true"
                        >
                            @for (theme of themes; track theme.id) {
                                <li class="agpr-theme-sidebarHeaderDropdown-theme">
                                    <div
                                        class="agpr-theme-sidebarHeaderDropdown-currentThemeIndicator"
                                        [ngClass]="{ 'agpr-theme-sidebarHeaderDropdown-currentThemeIndicator--display': currentTheme?.id === theme.id }"
                                    ></div>
                                    <div
                                        class="agpr-theme-sidebarHeaderDropdown-themeInfo"
                                        tabindex="0"
                                        [routerLink]="'/Social/themes/theme/' + theme.id + routeTypeToRouteLinkMap.get(socialRouteModel?.type)"
                                        (click)="closeThemeDropdown()"
                                        (keydown)="handleThemeDropdownItemKeyboardInput($event, theme)"
                                    >
                                        @if (theme.avatarUrl) {
                                            <img
                                                class="agpr-theme-sidebarHeaderDropdown-themeImage"
                                                [alt]="theme.name"
                                                [src]="theme.avatarUrl"
                                                aria-hidden="true"
                                            />
                                        } @else {
                                            <div
                                                class="agpr-theme-sidebarHeaderDropdown-themeImagePlaceholder"
                                                [style.color]="theme.avatarPlaceholderColor"
                                                [style.background-color]="theme.avatarPlaceholderBackgroundColor"
                                                aria-hidden="true"
                                            >
                                                <span>{{ theme.avatarPlaceholderText }}</span>
                                            </div>
                                        }

                                        <span
                                            class="agpr-theme-sidebarHeaderDropdown-themeName"
                                            [pTooltip]="theme.name"
                                            tooltipPosition="right"
                                        >
                                            {{ theme.name }}
                                        </span>
                                        @if (liveAgentCount(theme)) {
                                            <span
                                                role="img"
                                                class="agpr-theme-sidebarLiveAgentIcon fa-solid fa-signal-stream"
                                                [pTooltip]="liveAgentTooltip(theme)"
                                                tooltipPosition="right"
                                                [attr.aria-label]="liveAgentTooltip(theme)"
                                            ></span>
                                        }
                                    </div>
                                </li>
                            }
                        </ul>
                    </agpr-scroll-panel>
                    <div class="agpr-theme-sidebarHeaderDropdown-divider"></div>
                    <a
                        class="agpr-theme-sidebarHeaderDropdown-menuItem"
                        [routerLink]="'/Social/themes/'"
                    >
                        {{ 'Social.intelligence.theme.manageThemes' | localize }}
                    </a>
                    @if (!isArchiveSearch) {
                        <div class="agpr-theme-sidebarHeaderDropdown-divider"></div>
                        <button
                            class="agpr-theme-sidebarHeaderDropdown-menuItem"
                            (click)="openArchiveSearchWidget(archiveSearchMode.create)"
                        >
                            {{ 'Social.intelligence.theme.lhp.newArchiveSearch' | localize}}
                        </button>
                    }
                </div>
            }
        </div>
        <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
    </div>
    <ul class="agpr-theme-sidebarList">
        <div #sidebarLine class="agpr-theme-sidebarListLine"></div>
        <li
            #analytics
            id="analytics"
            class="agpr-theme-sidebarListItem"
            [routerLink]="analyticsRouterLink"
            routerLinkActive="agpr-theme-sidebarListItem--active"
            tabindex="0"
            (focus)="closeThemeDropdown()"
            (click)="animateSidebar(analytics)"
        >
            <span
                class="agpr-theme-sidebarListItemIcon fa-duotone fa-regular fa-chart-mixed"
                aria-hidden="true"
            ></span>
            <h2>{{ 'Social.intelligence.theme.analytics' | localize }}</h2>
        </li>
        <li
            #postFeed
            id="postFeed"
            class="agpr-theme-sidebarListItem"
            [routerLink]="postFeedRouterLink"
            routerLinkActive="agpr-theme-sidebarListItem--active"
            tabindex="0"
            (click)="animateSidebar(postFeed)"
        >
            <span
                class="agpr-theme-sidebarListItemIcon fa-kit-duotone fa-agpr-posts"
                aria-hidden="true"
            ></span>
            <h2>{{ 'Social.intelligence.theme.postFeed' | localize }}</h2>
        </li>
    </ul>
    <div class="agpr-theme-sidebarRule"></div>

    @if (isArchiveSearch) {
        @if (activeArchiveSearch) {
            <agpr-social-search-detail
                [activeSearch]="activeArchiveSearch"
            > </agpr-social-search-detail>
        }

        <agpr-split-button
            [id]="id + '.saveTopicButton'"
            label="Social.intelligence.theme.lhp.actions"
            [options]="saveActions"
            panelPositionY="top"
            [style]="buttonTypes.secondary"
            [caretDown]="false"
        ></agpr-split-button>
    } @else {
        <div
            class="agpr-theme-sidebarTopics"
            role="group"
            [attr.aria-label]="'Social.intelligence.theme.sidebarTopics.control' | localize"
        >
            <agpr-agent-filter
                #agentFilter
                class="agpr-theme-sidebarTopics-filter"
                [currentTheme]="currentTheme"
                [agents]="themeAgents"
                (enabledAgents)="updateAgentsStatus($event)"
                (createNewAgent)="openCreateAgentDialog()"
            ></agpr-agent-filter>
        </div>
    }

    <!-- Held at the foot of the panel, however far the topic list runs -->
    @if (hasAgenticFeature && !isArchiveSearch) {
        <div class="agpr-theme-sidebarAgents">
            <agpr-button
                [id]="id + '.agentsButton'"
                class="agpr-theme-sidebarAgents-button"
                label="Monitoring.result.agents"
                icon="fa-kit-duotone fa-agpr-ai-generic"
                [style]="buttonTypes.primary"
                [wide]="true"
                (click)="addLiveAgent()"
            ></agpr-button>
        </div>
    }
</div>
@if (changesPending) {
    <div class="agpr-theme-sidebar-message">
        <agpr-message
            [severity]='severityEnum.warning'
            [centerContent]="true"
            [noBottomCornerRadius]="true"
            [style]="componentStyle.social"
            [closeable]="true"
            (dismiss)="cancelChanges()"
        >
            <span>{{ 'Social.intelligence.theme.pendingChanges' | localize}}</span>
            <agpr-button
                class="agpr-theme-sidebar-message-link"
                label="Social.intelligence.theme.applyChanges"
                [style]="buttonTypes.link"
                (click)="confirmChange()"
            ></agpr-button>
        </agpr-message>
    </div>
}
